export default process.env.REQUEST_URL ||
  'https://synthopia-nft-dev.herokuapp.com';
